<section class="cp-section tool-rating" id="sec-reviews" data-section="reviews">
  <header class="cp-head">
  <h2 class="cp-h2" [style.border-color]="accent">Reviews</h2>
  <p class="cp-section-lead">What people who use {{ toolName }} say about it</p>
  </header>
  <div class="cp-main">

  <!-- laid out like a theme page's Reviews (owner, 2026-10-04): the box with the way to a
       review on top, the rating, then the comments as the home wall's bubbles -->
  <div class="tr-box" *ngIf="mineLoaded">
    <p class="tr-box-text" *ngIf="!summary || summary.count === 0">No reviews yet. Be the first to tell everyone what you think of {{ toolName }}.</p>
    <p class="tr-box-text" *ngIf="summary && summary.count > 0">Using {{ toolName }}? We would love to hear what you think.</p>
    <app-store-review-form [existing]="mine"
                           label="Write a Review"
                           namePlaceholder="Your name"
                           [requireText]="true"
                           [send]="send"
                           (saved)="onSaved($event)"></app-store-review-form>
  </div>

  <app-store-reviews *ngIf="summary && summary.count > 0"
                     [summary]="summary"
                     countLabel="from people using this tool"></app-store-reviews>

  <app-review-wall [reviews]="cards" [system]="true" [label]="'Reviews of ' + toolName"></app-review-wall>
  </div>
</section>
